"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var YourSavingsCardState = /** @class */ (function () {
    function YourSavingsCardState() {
        this.showPromoModal = false;
        this.promocodeDetails = '';
        this.savingsPanelError = false;
        this.errMsg = '';
        this.promoCodeSuccess = false;
        this.showSeeOfferDetailsModal = false;
    }
    return YourSavingsCardState;
}());
exports.default = YourSavingsCardState;
//# sourceMappingURL=YourSavingsCardState.js.map


//////////////////
// WEBPACK FOOTER
// ./node_modules/@idse/cart-ui/components/panels/PromoPanel/YourSavingsCard/YourSavingsCardState.js
// module id = 2242
// module chunks = 8